var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_1932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C10.4087 0 8.88258 0.632141 7.75736 1.75736C6.63214 2.88258 6 4.4087 6 6V42C6 43.5913 6.63214 45.1174 7.75736 46.2426C8.88258 47.3679 10.4087 48 12 48H36C37.5913 48 39.1174 47.3679 40.2426 46.2426C41.3679 45.1174 42 43.5913 42 42V6C42 4.4087 41.3679 2.88258 40.2426 1.75736C39.1174 0.632141 37.5913 0 36 0L12 0ZM12 3H36C36.7956 3 37.5587 3.31607 38.1213 3.87868C38.6839 4.44129 39 5.20435 39 6V42C39 42.7957 38.6839 43.5587 38.1213 44.1213C37.5587 44.6839 36.7956 45 36 45H12C11.2044 45 10.4413 44.6839 9.87868 44.1213C9.31607 43.5587 9 42.7957 9 42V6C9 5.20435 9.31607 4.44129 9.87868 3.87868C10.4413 3.31607 11.2044 3 12 3Z",
    fill: "#799AA9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0924 20.823L20.9399 21.4687L20.7554 22.3237L21.7679 22.5105C22.4294 22.668 22.5599 22.9065 22.4159 23.5657L20.7554 31.3687C20.3189 33.387 20.9916 34.3365 22.5734 34.3365C23.7996 34.3365 25.2239 33.7695 25.8696 32.991L26.0676 32.055C25.6176 32.451 24.9606 32.6085 24.5241 32.6085C23.9054 32.6085 23.6804 32.1742 23.8401 31.4092L26.0924 20.823ZM26.2499 16.125C26.2499 16.7217 26.0128 17.294 25.5909 17.716C25.1689 18.1379 24.5966 18.375 23.9999 18.375C23.4032 18.375 22.8309 18.1379 22.4089 17.716C21.9869 17.294 21.7499 16.7217 21.7499 16.125C21.7499 15.5283 21.9869 14.956 22.4089 14.534C22.8309 14.1121 23.4032 13.875 23.9999 13.875C24.5966 13.875 25.1689 14.1121 25.5909 14.534C26.0128 14.956 26.2499 15.5283 26.2499 16.125Z",
    fill: "#799AA9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_1932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.5467ea86e6949f6c8805caa8836e2040.svg";
export { ForwardRef as ReactComponent };